/* eslint-disable @angular-eslint/prefer-inject */
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { TegelModule } from '@scania/tegel-angular-17';
import { CommonModule } from '@angular/common';
import { ModalService } from '../shared/services/modal.service';
import { ConfirmationModalComponent } from '../shared/components/confirmation-modal/confirmation-modal.component';
import { Truck } from './models/truck.model';
import { TrucksService } from './services/trucks.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-trucks',
  templateUrl: './trucks.component.html',
  styleUrls: ['./trucks.component.scss'],
  standalone: true,
  imports: [ConfirmationModalComponent, TegelModule, CommonModule],
})
export class TrucksComponent implements OnInit {
  trucks: Truck[] = [];
  deletionId: number = 0;

  constructor(
    private router: Router,
    private truckService: TrucksService,
    public modalService: ModalService,
  ) {}

  ngOnInit(): void {
    this.truckService.getTrucks().subscribe((trucksResponse) => {
      this.trucks = trucksResponse;
    });
  }

  editTruck(truckId: number): void {
    void this.router.navigate([`trucks/edit/${truckId}`]);
  }

  deleteTruck(id: number): void {
    if (id) {
      const truckIndex: number = this.trucks.findIndex((x) => x.Id === id);
      this.trucks.splice(truckIndex, 1);
    }
  }

  createTruck(): void {
    const newTruckId = this.truckService.createTruck();

    void this.router.navigate([`trucks/edit/${newTruckId}`]);
  }
}
